<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
           
            <div class="z-index pb-2">
                <div class="text-center">
                  <div class="whats-new-label box-shadow mx-auto">
                    <div class="wave-container">
                      <div class="wave-dot wave-dot-1"></div>
                      <div class="wave-dot wave-dot-3"></div>
                    </div>
                    <span class="paragraph-global-text sub-head-paragraph">
                      {{'client.banner.preTitle' | translate}}
                    </span>
                  </div>
                
                  <h1 class="banner-heading mx-auto">{{'client.banner.title' | translate}}</h1>
                  <p class="paragraph-global-text mw-800 mx-auto">{{'client.banner.description' | translate}}</p>
                  <div class="d-flex align-items-center justify-content-center my-3">
                    <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                      <button class="save-btn cfa">
                        {{'client.banner.btnText' | translate}}
                        <i class="pi pi-arrow-right title-color ml-2"></i>
                      </button>
                    </a>
                  </div>
                  <div class="mt-4 d-flex justify-content-center">
                    <p class="paragraph-global-text sub-head-paragraph mw-500 mb-0">
                      {{'client.banner.btnText2' | translate}},
                    </p>
                    <p class="paragraph-global-text sub-head-paragraph mw-500 mb-0 ml-2">
                      {{'client.banner.btnText3' | translate}}
                    </p>
                  </div>
                </div>
            </div>
        </div>
    </div>    
</div>


<section>
    <div class="sec-padding videos-sec">
        <div class="container">
            <div class="sec-title mb-5 text-center">
                <div class="mx-auto whats-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div>   
                    <span class=" paragraph-global-text">
                        {{'client.costCompare.preTitle' | translate}}
                    </span>
                </div>
                <h2 class="heading-one mx-auto">{{"client.costCompare.title" | translate}} </h2>
                <p class="paragraph-global-text mw-900 sub-head-paragraph mx-auto">{{"client.costCompare.description" | translate}}</p>
            </div>
           
            <figure class="preview-img-sec">
                <img class="w-100 mt-5 preview-img" src="../../assets/icons/Homepage/video-preview.svg" alt="">
                <img class="previewIcon" width="80" src="../../assets/icons/Homepage/preview-icon.svg" alt="">
            </figure>
        </div>
    </div>
</section>

<div class="sec-padding sec-primary-background">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <div class="mx-auto whats-new-label">
                <div class="wave-container">
                    <div class="wave-dot wave-dot-1"></div> 
                    <div class="wave-dot wave-dot-3"></div> 
                </div>   
                <span class=" paragraph-global-text">
                    {{'client.agencyTalent.preTitle' | translate}}
                </span>
            </div>
            <h2 class="heading-one mx-auto mw-900"> {{"client.agencyTalent.title" | translate}}</h2>
            <p class="paragraph-global-text mw-800 sub-head-paragraph gray-description mx-auto">{{"client.agencyTalent.description" | translate}}</p>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-building-2 icon-primary-color"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/></svg>
                     </div>
                     <h4 class="heading-three pt-1">{{'client.agencyTalent.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'client.agencyTalent.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up icon-primary-color"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'client.agencyTalent.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'client.agencyTalent.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check icon-primary-color"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'client.agencyTalent.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'client.agencyTalent.section3.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-check icon-primary-color"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="m9 15 2 2 4-4"/></svg>
                    </div>                    
                     <h4 class="heading-three pt-1">{{'client.agencyTalent.section4.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'client.agencyTalent.section4.description' | translate}}</p>
                </div>
             </div>
            </div>
        </div>
    </div>
    

    <div class="sec-padding">
        <div class="container">
            <div class="sec-title pb-3 mb-5 text-center">
                <div class="mx-auto whats-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div>   
                    <span class=" paragraph-global-text">
                        {{'client.hiringCompanies.preTitle' | translate}}
                    </span>
                </div>
                <h2 class="heading-one mx-auto mw-1000"> {{"client.hiringCompanies.title" | translate}}</h2>
                <p class="paragraph-global-text mw-800 sub-head-paragraph gray-description mx-auto">{{"client.hiringCompanies.description" | translate}}</p>
            </div>
            <div class="mw-800 mx-auto">
                <div class="table-responsive">
                  <table class="table table-bordered text-center card-radius">
                    <thead class="bg-primary text-white">
                      <tr>
                        <th scope="col" class="text-start">Feature</th>
                        <th scope="col">Free</th>
                        <th scope="col">Premium</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-start">Access to standard features</td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                      </tr>
                      <tr>
                        <td class="text-start">Basic agreements</td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                      </tr>
                      <tr>
                        <td class="text-start">Custom agreements</td>
                        <td>–</td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                      </tr>
                      <tr>
                        <td class="text-start">Priority support</td>
                        <td>–</td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                      </tr>
                      <tr>
                        <td class="text-start">Analytics</td>
                        <td>–</td>
                        <td><i class="pi pi-check-circle text-green"></i></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="mt-5 pt-4">
                <a [routerLink]="'/en/pricing'">
                    <button class="save-btn cfa mx-auto fw-500">
                      {{'client.hiringCompanies.btnBtx' | translate}}
                    </button>
                </a>
            </div>
        </div>
    </div>


    <div class="sec-padding sec-primary-background">
        <div class="container">
            <div class="sec-title pb-3 mb-5 text-center">
                <div class="mx-auto whats-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div>   
                    <span class=" paragraph-global-text">
                        {{'client.payment.preTitle' | translate}}
                    </span>
                </div>
                <h2 class="heading-one mx-auto mw-1000"> {{"client.payment.title" | translate}}</h2>
                <p class="paragraph-global-text mw-900 sub-head-paragraph gray-description mx-auto">{{"client.payment.description" | translate}}</p>
            </div>
            <div class="table-wrapper mw-1200 mx-auto">
              <table class="table-custom">
                <thead>
                  <tr>
                    <th>Stage</th>
                    <th>Payment Terms</th>
                    <th>Details</th>
                    <th>Additional Info</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 Week trial</td>
                    <td>1 week</td>
                    <td>$10 (To avoid non-serious people)</td>
                    <td>This amount will be refunded/adjusted in the billing when you hire resources.</td>
                  </tr>
                  <tr>
                    <td>First payment</td>
                    <td>Pay for 80 hours of work in advance paid to Amy</td>
                    <td>After 15 days, you can release the amount to the agency.</td>
                    <td>The agency gets paid only when you release the amount after the work is completed.</td>
                  </tr>
                  <tr>
                    <td>Second payment</td>
                    <td>Pay for 80 hours of work in advance</td>
                    <td>Also adjust the actual hours worked from the first 15 days (if more or fewer hours worked).</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>Third payment</td>
                    <td>Round off to the 1st of every month</td>
                    <td>Pay in advance</td>
                    <td>This step ensures the payments are done on the 1st of every month from this period.</td>
                  </tr>
                  <tr>
                    <td>Fourth payment</td>
                    <td>T+7 days</td>
                    <td>No more advance payments</td>
                    <td>The agency works for the whole month and raises an invoice on the 1st of the next month. You should pay the invoice within 7 working days.</td>
                  </tr>
                  <tr>
                    <td>Fifth payment</td>
                    <td>T+30 days</td>
                    <td>Get work done the whole month. Raise invoice on the 1st.</td>
                    <td>Get work for a month and pay within 7 days.</td>
                  </tr>
                  <tr>
                    <td>Upon contract cancellation</td>
                    <td>Pay the whole amount</td>
                    <td>+ 5 working days of notice period (40 hours) in advance</td>
                    <td>Pay the invoice by the end of the next month.</td>
                  </tr>
                  <tr>
                    <td>Upon 40 hours notice period completion</td>
                    <td>Contract ends</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>              
              </div>
        </div>
        <div class="container z-index pt-5 mt-3">
            <div class="sec-title text-center">            
                <h2 class="heading-two mx-auto">{{'client.payment.subTitle' | translate}}</h2>
                <p class="paragraph-global-text sub-head-paragraph mw-600">{{'client.payment.subDescription' | translate}}</p>
      
                <div>
                    <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                        <button class="save-btn cfa mx-auto fw-500 mt-4">
                          {{'client.payment.btnText' | translate}}
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>

    
    <div class="sec-padding industries-list-section sec-primary-background" *ngIf="templates && templates?.length > 0">
        <div class="container position-relative">
            <div class="sec-title pb-3 mb-5 text-center">
                <div class="mx-auto whats-new-label transparent-bg">
                    <div class="wave-container white-waves">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div>   
                    <span class="text-white paragraph-global-text">
                        {{'client.industries.preTitle' | translate}}
                    </span>
                </div>
                <h2 class="heading-one mx-auto text-white mw-1100"> {{"client.industries.title" | translate}}</h2>
                <p class="paragraph-global-text text-white mx-auto">{{"client.industries.description" | translate}}</p>
            </div>
            <div class="row mx-0 m-col-width">
            <div class="agency-grid mt-4">
                <div class="agency-card" *ngFor="let template of templates">
                <div class="template-icon w-fit h-fit">
                    <img width="20" height="20" src="{{template.thumbnailImageUrl}}">
                </div>
                <h5 class="heading-four mb-0">{{ template.templateName }}</h5>
                </div>
            </div>
            </div>
        </div>
    </div>

    <!-- testimonials  section-->
    <div class="sec-padding testimonials-sec">
        <div class="container position-relative">
            <span class="group-shadow-active-card-t"></span>
            <span class="group-shadow-active-card-orage-l"></span>
            <span class="group-shadow-active-card-orage-r"></span>
            <div class="sec-title pb-3 mb-5 text-center">
                <div class="mx-auto whats-new-label">
                    <!-- <img width="18" class="mr-3" src="../../assets/icons/Homepage/reviews/review-pre.svg"> -->
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div>   
                    <span class=" paragraph-global-text">
                        {{'client.testimonials.preTitle' | translate}}
                    </span>
                </div>
                <h2 class="heading-one mx-auto mw-800">{{"client.testimonials.title" | translate}}</h2>
                <p class="paragraph-global-text mw-700 sub-head-paragraph mx-auto pb-0">{{"client.testimonials.description" | translate}}</p>
            </div>
            <div class="row">
                <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                    <div class="card why-amy-cards reviews">
                       <div>
                            <div class="d-flex align-items-center mb-4 w-100">
                                <app-start-rating-readonly [rating]="rating1"></app-start-rating-readonly>                          
                                <span class="ml-2 sub-heading-color">{{rating1 | number: '1.1-1' }}</span>
                            </div>
                            <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'client.testimonials.section1.review' | translate}}”</p>
                       </div>
                         <div class="d-flex align-items-center mt-3">
                            <div>
                                <h6 class="card-title mb-1">{{'client.testimonials.section1.title' | translate}}</h6>
                                <span class="sub-heading-color">{{'client.testimonials.section1.role' | translate}}</span>
                            </div>
                         </div>
                    </div>
                 </div>
                 <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                    <div class="card why-amy-cards reviews">
                        <div>
                            <div class="d-flex align-items-center mb-4 w-100">
                                <app-start-rating-readonly [rating]="rating2"></app-start-rating-readonly>                          
                                <span class="ml-2 sub-heading-color">{{rating2 | number: '1.1-1' }}</span>
                            </div>
                             <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'client.testimonials.section2.review' | translate}}”</p>
                        </div>
                         <div class="d-flex align-items-center mt-3">
                            <div class="">
                                <h6 class="card-title mb-1">{{'client.testimonials.section2.title' | translate}}</h6>
                                <span class="sub-heading-color">{{'client.testimonials.section2.role' | translate}}</span>
                            </div>
                         </div>
                    </div>
                 </div>
                 <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                    <div class="card why-amy-cards reviews">
                        <div>
                            <div class="d-flex align-items-center mb-4 w-100">
                                <app-start-rating-readonly [rating]="rating3"></app-start-rating-readonly>                          
                                <span class="ml-2 sub-heading-color">{{rating3 | number: '1.1-1' }}</span>
                            </div>
                             <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'client.testimonials.section3.review' | translate}}”</p>
                        </div>
                         <div class="d-flex align-items-center mt-3">
                            <div class="">
                                <h6 class="card-title mb-1">{{'client.testimonials.section3.title' | translate}}</h6>
                                <span class="sub-heading-color">{{'client.testimonials.section3.role' | translate}}</span>
                            </div>
                         </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>


    <!-- faqs  -->
  <div class="sec-padding mcqs-sec sec-primary-background">
    <div class="container">
      <div class="text-center mb-5 pb-4">
        <div class="content-sec">
          <h1 class="heading-one">
            {{'amyServiceProvider.faqSection.title' | translate}}
            {{'amyServiceProvider.faqSection.title2' | translate}}
          </h1>
          <p class="paragraph-global-text mw-800 sub-head-paragraph gray-description mx-auto">{{"amyServiceProvider.faqSection.description" | translate}}</p>
        </div>
      </div>
  
      <div class="accordion mw-800 mx-auto">
        <div class="expansion-panel-group">
          <div
            *ngFor="let panel of faqAccordion; let i = index"
            class="expansion-panel"
            [class.active]="expandedIndex === i"
          >
            <!-- Panel Header -->
            <div class="expansion-panel-header" (click)="togglePanel(i)">
              <span class="heading-three" [class.active]="expandedIndex === i">{{ panel.sectionTitle}}</span>
              <svg
                
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.filter-blue]="expandedIndex === i"
                [class.expanded]="expandedIndex === i"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
        
            <!-- Panel Content -->
            <div class="expansion-panel-content"
              [style.maxHeight]="expandedIndex === i ? contentHeights[i] + 'px' : '0px'">
              <div #contentWrapper class="content-wrapper" style="gap: 25px;">
               <ng-container *ngFor="let que of panel.questions">
                  <div class="card why-amy-cards transparent-bg mt-1 mb-3">
                    <div class="d-flex align-items-center mb-1">
                      <h6 class="heading-four mb-0">{{que.question}}</h6>
                    </div>
                    <p class="paragraph-global-text mb-0">{{que.answer}}</p>
                  </div>
               </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- cfa  -->
  <div class="sec-padding cfa-sec position-relative">    
    <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">            
            <h2 class="heading-one text-white mx-auto">{{'client.cfa.title' | translate}}
              {{'client.cfa.title2' | translate}} </h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800 text-white">{{'client.cfa.description' | translate}}</p>
  
            <div>
                <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                    <button class="save-btn cfa mx-auto fw-500 mt-4">
                      {{'client.cfa.btnText' | translate}}
                    </button>
                </a>
            </div>
        </div>
    </div>
  </div>
